/* eslint-disable */

/**
 * This Enum maps to available sorting types supported in our ES query,
 * caller pick the desired type of sorting to use
 */
export enum SortByType {
  /** NO_SORT - no specific sorting order */
  NO_SORT = "NO_SORT",
  /** @deprecated */
  RELEVANCE = "RELEVANCE",
  /** POPULAR -  */
  POPULAR = "POPULAR",
  DEAL_START = "DEAL_START",
  DEAL_END = "DEAL_END",
  /** DEFAULT - TODO: clarify naming, current behavior is match to Afterpay ordering if exists */
  DEFAULT = "DEFAULT",
  /** P13N - sort by personalization */
  P13N = "P13N",
}

export enum SortByOrder {
  DESC = "DESC",
  ASC = "ASC",
}
